import { useMemo } from "react";

const getInitials = (string = "") => {
  if (!string || !string?.trim()) return;
  const nameString = string.trim();
  const names = nameString.split(" ");
  const initials = names[0]?.[0]?.toUpperCase() || "";

  if (names.length > 1) {
    return initials + names[names.length - 1][0].toUpperCase();
  }
  return initials;
};

const generateColor = (name, isDark = false) => {
  const safeName = name || "";
  const hash = safeName.split("").reduce((acc, char) => {
    return char.charCodeAt(0) + ((acc << 5) - acc);
  }, 0);

  if (isDark) {
    const h = hash % 360;
    return `hsl(${h}, 70%, 35%)`;
  } else {
    const h = hash % 360;
    return `hsl(${h}, 70%, 85%)`;
  }
};

const UserAvatar = ({ name, theme = "light", showName = true, className = "" }) => {
  const safeName = name || "";
  const initials = useMemo(() => getInitials(safeName), [safeName]);
  const backgroundColor = useMemo(() => generateColor(safeName, theme === "dark"), [safeName, theme]);

  return (
    <div className="tw-flex tw-items-center tw-gap-2">
      <div
        className={`tw-flex tw-items-center tw-justify-center tw-size-8 tw-text-label-sm tw-rounded-full tw-font-medium tw-text-gray-700 ${className}`}
        style={{ backgroundColor }}
      >
        {initials}
      </div>
      {showName && <span>{safeName}</span>}
    </div>
  );
};

export default UserAvatar;
